import React, { useState, useEffect, useRef } from 'react'
import './events.css'
import dummy from "../../assets/images/cert.svg";
import WmModals from "../../modals/Wm.Modals"
import Wmbutton from "../../ui-components/wm-button/Wm.button";
import Table from 'react-bootstrap/Table'
import { getCertificateTemplates, createEvent, generateCSV,getCredits } from '../../functions/certificatesAPI';
import { useHistory } from "react-router-dom"
import Required from "../../Components/required/Required"
import CircularProgress from "@material-ui/core/CircularProgress";
import { connect } from "react-redux";
import readXlsxFile from 'read-excel-file'
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
import Moment from 'react-moment';
import API_ENDPOINT from "../../wm.api.service";
function AddEvents({ rootData }) {
    const dateField = useRef(null);
    const eventInput = useRef(null);
    let history = useHistory();
    const [addEventModal, setAddEventModal] = useState(false)
    const [certImg, setCertImg] = useState(dummy)
    // Create Event
    const [eventName, setEventName] = useState('');
    const [eventDate, setEventDate] = useState('');
    const [eventSubject, setEventSubject] = useState('');
    const [eventContent, setEventContent] = useState('');
    const [prefix, setPrefix] = useState('');
    const [header, setHeader] = useState([])
    // Upload Event CSV
    const [csvFile, setCsvFile] = useState(null);
    const [csvData, setCsvData] = useState([]);
    const [csvDataCount, setCsvDataCount] = useState('');
    const [isLimitExi, setLimitExi] = useState(false);
    const [isCsvAdded, setCsvAdded] = useState(false);
    const [credits,setCredits] = useState('')
    const csvReadFile = useRef(null)
    function handleImageClick() {
        csvReadFile.current.click();
    }
    const readFile = (file) => {
        setCsvFile(file)
        readXlsxFile(file).then((rows) => {
            setCsvDataCount(rows.length - 1);
            if (rows.length - 1 > +credits) {
                setLimitExi(true)
            } else {
                setCsvData(rows)
                setCsvAdded(true);
            }
        })
    }
    // Fetching template
    const [templates, setTemplates] = useState([]);
    const [templateFields, setTemplateFields] = useState("");
    useEffect(() => {
        fetchTemplates()
    }, [])
    const fetchTemplates = () => {
        getCertificateTemplates()
            .then(response => {
                setTemplates(response?.data)
            })
            .catch(err => {
                console.log(err)
            })
    }

    // Create Event
    const [isCreatingEvent, setIsCreatingEvent] = useState(false);
    const [tempId, setTempId] = useState('')
    const handleCreateEvent = () => {
        setIsCreatingEvent(true)
        createEvent(eventName, eventDate, tempId, csvFile, csvDataCount, eventSubject, eventContent,prefix)
            .then(function (res) {
                setIsCreatingEvent(false)
                history.push('/i/institute/events')
            })
            .catch(function (err) {
                setIsCreatingEvent(false)
                console.log(err)
            })
    }

    const [isTempleteSelected, setTempleteSelected] = useState(false)
    const handleSelectTemplate = (tempId, tempImg) => {
        setCertImg(tempImg)
        setTempleteSelected(true)
        setTempId(tempId)
    }

    const downloadXlsx = () => {
        generateCSV(tempId)
            .then(function (res) {
                console.log(res);
            })
            .catch(function (err) {
                console.log(err)
            })
    }

    const handleOpenCalander = () => {
        dateField.current.focus();
    }
    const validateInputs = () => {
        let isSafe = true;
        if (eventName === '' || eventName === null || eventName === undefined) {
            isSafe = false;
            alert("Please enter a name for the event")
            eventInput.current.focus()
        }
        if (eventDate === '' || eventDate === null || eventDate === undefined) {
            isSafe = false;
            alert("Please enter a date for the event")
            dateField.current.focus()
        }
        return isSafe;
    }
    const selectEventModal = () => {
        if (validateInputs()) {
            setAddEventModal(true)
        }
    }
    useEffect(() => {
        getCredits()
        .then((res) => {
            setCredits(res.data.credits)
        })
        .catch((err) => {
            console.error(err)
        })
    },[])
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-5">
                        <div className="wm_form_group flex flex-col mb-4">
                            <label className="wm_form_label">Event Name <Required /></label>
                            <input ref={eventInput} type="text" name="grade" placeholder="Event Name" className="wm_form_input border-bottom border-gray-300" value={eventName} onChange={(e) => setEventName(e.target.value)} />
                        </div>
                        <div className="row">
                        <div className="col-md-6">
                            <div className="wm_form_group flex flex-col mb-4">
                                <div className="flex space-x-3">
                                    <label className="wm_form_label">Mail Subject</label>
                                    <Tooltip
                                        title={
                                            <React.Fragment>Mail Subject</React.Fragment>
                                        }
                                        placement="right"
                                    >
                                        <HelpIcon />
                                    </Tooltip>
                                </div>
                                <input type="text" name="grade" placeholder="Mail Subject" className="wm_form_input border-bottom border-gray-300" value={eventSubject} onChange={(e) => setEventSubject(e.target.value)} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="wm_form_group flex flex-col mb-4">
                                <div className="flex space-x-3">
                                    <label className="wm_form_label">Prefix</label>
                                    <Tooltip
                                        title={
                                            <React.Fragment>Prefix</React.Fragment>
                                        }
                                        placement="right"
                                    >
                                        <HelpIcon />
                                    </Tooltip>
                                </div>
                                <input type="text" name="grade" placeholder="Prefix" className="wm_form_input border-bottom border-gray-300" value={prefix} onChange={(e) => setPrefix(e.target.value)} />
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className="col-md-5">
                        <div className="wm_form_group flex flex-col mb-4">
                            <label className="wm_form_label">Date of event <Required /></label>
                            <input onClick={handleOpenCalander} ref={dateField} type="date" name="grade" className="wm_form_input border-bottom border-gray-300" value={eventDate} onChange={(e) => setEventDate(e.target.value)} />
                        </div>
                        <div className="wm_form_group flex flex-col mb-4">
                            <div className="flex space-x-3">
                                <label className="wm_form_label">Mail Content</label>
                                <Tooltip
                                    title={
                                        <React.Fragment>Mail Content</React.Fragment>
                                    }
                                    placement="right"
                                >
                                    <HelpIcon />
                                </Tooltip>
                            </div>
                            <input type="text" name="grade" placeholder="Mail Content" className="wm_form_input border-bottom border-gray-300" value={eventContent} onChange={(e) => setEventContent(e.target.value)} />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div>
                            <div className="credites">
                                <div className='mb-2'>
                                    <span className="block manpro text-xl font-semibold text-center">Credits: {+credits}</span>
                                </div>
                            </div>
                            <div className="text-center">
                                <div onClick={selectEventModal} className="fileImageWrapper w-full h-28 flex justify-center items-center rounded-xl border-gray-300 border-2 border-dashed cursor-pointer overflow-hidden">
                                    <img className="object-cover w-24" src={certImg} alt="education" />
                                </div>
                                <small className='manpro text-gray-500'>select template</small>
                                <div>
                                    <input hidden ref={csvReadFile} className="form-control form-control-sm" type="file" onChange={e => readFile(e.target.files[0])} accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
                                    <Wmbutton label={'upload CSV'} className="w-full rounded-3xl" type="button" color="primary" onClick={handleImageClick} />
                                </div>
                                {isCsvAdded && <div>
                                    <Wmbutton label={isCreatingEvent ? (<CircularProgress className="loader_size_xsm text-white" />) : ("Create Event")} className="w-full rounded-3xl mt-3" type="button" color="primary" onClick={handleCreateEvent} />
                                </div>}
                            </div>
                        </div>
                    </div>
                    {csvData.length > 0 && <div className="col-md-12 mt-3 overflow-auto">
                        <Table striped bordered hover size="sm">
                            <thead>
                                <tr>
                                    <th className='w-1/12'>Sr.no</th>
                                    {csvData.slice(0, 1).map((header, idx) => {
                                        return header.map((data, idx) => {
                                            return <th key={idx}>{data}</th>
                                        })
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {csvData.slice(1).map((data, idx) => {
                                    return <tr key={idx}>
                                        <td>{idx + 1}</td>
                                        {data.map((header, idx) => {
                                            if (header instanceof Date) {
                                                return <td key={idx}>
                                                    <Moment date={header} format='DD/MM/YYYY' />
                                                </td>
                                            } else {
                                                return <td key={idx}>{header}</td>
                                            }
                                        })}
                                    </tr>
                                })}
                            </tbody>
                        </Table>
                    </div>}

                </div>
            </div>
            <WmModals show={addEventModal} onHide={() => setAddEventModal(false)} size="lg" className="">
                <div className="px-3 py-3">
                    <h5 className="">Select Template</h5>
                    <div className='py-2 certificate-show-area'>
                        <div className="row">
                            {templates.length > 0 ? templates.map((template, index) => {
                                return <div className="col-md-6" key={index} onClick={() => handleSelectTemplate(template.template_id, template.url)}>
                                    <label class="labl w-full cursor-pointer h-64 mb-2">
                                        <input type="radio" name="radioname" value="one_value" />
                                        <div className='w-full cursor-pointer h-64 mb-2'>
                                            <div className='w-full h-5/6 border border-gray-300 rounded-md p-2'>
                                                <img src={template.url} alt="cert1" className="w-full h-full object-contain" />
                                            </div>
                                            <small className='block text-center text-gray-700 font-semibold mt-2 text-base'>{template.template_name}</small>
                                        </div>
                                    </label>
                                </div>
                            }) : <div className="col-md-12 mt-2">
                                <span className="block manpro text-xl font-semibold text-center">No Templates Found</span>
                            </div>}
                        </div>
                    </div>
                    <div className='py-1'>
                        <div className="row justify-end">
                            {isTempleteSelected && <div className="col-md-4" onClick={() => setAddEventModal(false)}>
                                <div className="h-full">
                                    {/* <button type="button" className="wmbutton-color-white h-full w-full rounded-3xl primary flex items-center justify-center text-center text-white"
                                        onClick={downloadXlsx}
                                    >
                                        Select and download CSV
                                    </button> */}
                                    <a
                                        className="wmbutton-color-white h-full w-full rounded-3xl primary flex items-center justify-center text-center text-white"
                                        href={`${API_ENDPOINT.apiURL}Certificate/generateCsv?templateId=${tempId}`}
                                        target="_blank"
                                    >
                                        Select and download CSV
                                    </a>
                                    {/* <CSVLink className="wmbutton-color-white h-full w-full rounded-3xl primary flex items-center justify-center text-center text-white" data={templateFields} filename={`${eventName}data.xlsx`}>Select and download CSV</CSVLink> */}
                                </div>
                            </div>}
                            <div className="col-md-2">
                                <div>
                                    <Wmbutton label={'cancel'} onClick={() => setAddEventModal(false)} className="w-full rounded-3xl" type="button" color="primary" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </WmModals>
            <WmModals show={isLimitExi} onHide={() => setLimitExi(false)} size="md" className="">
                <div className="px-3 py-3">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <h5 className="block manpro text-lg text-red-500">Unable to begin process</h5>
                            </div>
                            <div className="col-md-12">
                                <div className="mb-3">
                                    <span className="block manpro text-sm text-gray-500">
                                        ⚠️  It seems like your credit limit is over
                                        please contact admin
                                    </span>
                                </div>
                            </div>
                            <div className="col-md-12 border-t border-gray-300">
                                <div className="row justify-end">
                                    <div className="col-md-4 mt-2">
                                        <div>
                                            <Wmbutton label={'cancel'} onClick={() => setLimitExi(false)} className="w-full rounded-3xl" type="button" color="primary" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </WmModals>
        </>
    )
}

const mapStateToProps = (state) => {
    return state;
};

export default connect(mapStateToProps, null)(AddEvents)
